import { Link } from "@tanstack/react-router";

import { TelegramConnectGuide } from "@/components/vip-chat/TelegramConnectGuide";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useAuth } from "@/lib/auth";
import { SUPER_SUB_TELEGRAM_MODAL } from "@/lib/super-sub-telegram";
import { useModalParam } from "@/lib/url-modal";

export function SuperSubTelegramWelcomeDialog() {
  const [open, setOpen] = useModalParam(SUPER_SUB_TELEGRAM_MODAL);
  const { signedIn, user } = useAuth();

  if (!signedIn) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>You&apos;re a Super Sub</DialogTitle>
          <DialogDescription>
            Your membership is active. Next, connect Telegram so you can join the VIP group
            chat with Ross and other Super Subs.
          </DialogDescription>
        </DialogHeader>

        <TelegramConnectGuide userId={user?.uid} />

        <DialogFooter className="gap-2 sm:justify-between">
          <Button asChild variant="outline" onClick={() => setOpen(false)}>
            <Link to="/library">Continue to library</Link>
          </Button>
          <Button asChild onClick={() => setOpen(false)}>
            <Link to="/vip-chat">Open VIP Chat</Link>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
